import { put, call, takeLatest } from 'redux-saga/effects'

import {
  deleteTag as deleteGLCodeApi,
  getTags as getGLCodesApi,
  createTag as createGLCodeApi,
  updateTag as updateGLCodeApi,
  getExpenseGLCodesTag as getExpenseGLCodesApi,
} from 'Service/Api'
import { GL_CODE_PARAM } from 'Constants'

import * as GLCodeTypes from 'Redux/Types/GLCodeTypes'
import * as GLCodeActions from 'Redux/Actions/GLCodeActions'

function* getGLCodes() {
  try {
    const { data } = yield call(getGLCodesApi, GL_CODE_PARAM)
    yield put(GLCodeActions.getGLCodesSucceeded(data))
  } catch (errors) {
    yield put(GLCodeActions.getGLCodesFailed(errors))
  }
}

function* addGlCode({ payload }) {
  const { searchTerm, resolve, reject } = payload
  const params = {
    value: searchTerm,
    type: { name: GL_CODE_PARAM },
  }
  try {
    const { data } = yield call(createGLCodeApi, params)
    yield put(GLCodeActions.addGLCodeSucceeded(data))
    if (resolve) {
      resolve(data)
    }
  } catch (errors) {
    yield put(GLCodeActions.addGLCodeFailed(errors))
    if (reject) {
      reject(errors)
    }
  }
}

function* deleteGLCode({ payload }) {
  try {
    yield call(deleteGLCodeApi, payload)
    yield put(GLCodeActions.deleteGLCodeSucceeded(payload))
  } catch (errors) {
    yield put(GLCodeActions.deleteGLCodeFailed(errors))
  }
}

function* updateGLCode() {
  try {
    const { data } = yield call(updateGLCodeApi, GL_CODE_PARAM)
    yield put(GLCodeActions.updateGLCodeSucceeded(data))
  } catch (errors) {
    yield put(GLCodeActions.updateGLCodeFailed(errors))
  }
}

function* getExpenseCategoryGLCodes({ payload }) {
  try {
    const { data } = yield call(getExpenseGLCodesApi, payload)
    yield put(GLCodeActions.fetchExpenseGlCodeTagsSucceeded(data))
  } catch (errors) {
    yield put(GLCodeActions.fetchExpenseGlCodeTagsFailed(errors))
  }
}

export default function* GLCodeSaga() {
  yield takeLatest(GLCodeTypes.DELETE_GL_CODE, deleteGLCode)
  yield takeLatest(GLCodeTypes.GET_GL_CODES, getGLCodes)
  yield takeLatest(GLCodeTypes.ADD_GL_CODE, addGlCode)
  yield takeLatest(GLCodeTypes.UPDATE_GL_CODE, updateGLCode)
  yield takeLatest(GLCodeTypes.FETCH_EXPENSE_GLCODE_TAGS, getExpenseCategoryGLCodes)
}
